export const SIDEBAR_OPEN_WIDTH = 280;
export const SIDEBAR_CLOSED_WIDTH = 64;
